import { render, staticRenderFns } from "./AddVendorHeader.vue?vue&type=template&id=88e1363e"
import script from "./AddVendorHeader.vue?vue&type=script&lang=js"
export * from "./AddVendorHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports